export const CLOCKIN_LINETYPE_OPTIONS = [
  { Value: 'J', DisplayValue: 'J - Job' },
  { Value: 'S', DisplayValue: 'S - SM WorkOrder' },
  { Value: 'M', DisplayValue: 'M - Mechanic' },
];

export enum ClockInType
{
  Job = 'J',
  Service = 'S',
  Mechanic = 'M'
}